export const getPercentage = (a: number, b: number) => {
	if (a === 0 || b === 0) {
		return 0.0
	}
	return Number(((a / b) * 100).toFixed(2))
}

export const cx = (...classes: string[]) => classes.filter(Boolean).join(' ')
